var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-detail"},[_c('div',{staticClass:"video-box"},[_c('empty-box',{attrs:{"desc":"请使用微信扫描二维码"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }